/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    BulkImportResult,
    BulkImportVehicleModelReferencesRequest,
    CreateUpdateVehicleModelReferenceRequest,
    VehicleModelOptionDto,
    VehicleModelReferenceDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    BulkImportResultFromJSON,
    BulkImportResultToJSON,
    BulkImportVehicleModelReferencesRequestFromJSON,
    BulkImportVehicleModelReferencesRequestToJSON,
    CreateUpdateVehicleModelReferenceRequestFromJSON,
    CreateUpdateVehicleModelReferenceRequestToJSON,
    VehicleModelOptionDtoFromJSON,
    VehicleModelOptionDtoToJSON,
    VehicleModelReferenceDtoFromJSON,
    VehicleModelReferenceDtoToJSON,
} from "../models/index";

export interface BulkImportVehicleModelReferencesOperationRequest {
    body?: BulkImportVehicleModelReferencesRequest;
}

export interface CreateVehicleModelReferenceRequest {
    body?: CreateUpdateVehicleModelReferenceRequest;
}

export interface DeleteVehicleModelReferenceRequest {
    id: number;
}

export interface GetVehicleModelReferenceModelsRequest {
    make: string;
}

export interface UpdateVehicleModelReferenceRequest {
    id: number;
    body?: CreateUpdateVehicleModelReferenceRequest;
}

/**
 *
 */
export class VehicleModelReferencesHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Bulk-import catalog entries from a JSON array. All-or-nothing: if any row is invalid, duplicated within the file, or already exists, nothing is written and a per-row error report is returned. Requires system_vehicle_model_manage.
     */
    async bulkImportVehicleModelReferencesRaw(
        requestParameters: BulkImportVehicleModelReferencesOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<BulkImportResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references/bulk`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: BulkImportVehicleModelReferencesRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            BulkImportResultFromJSON(jsonValue),
        );
    }

    /**
     * Bulk-import catalog entries from a JSON array. All-or-nothing: if any row is invalid, duplicated within the file, or already exists, nothing is written and a per-row error report is returned. Requires system_vehicle_model_manage.
     */
    async bulkImportVehicleModelReferences(
        requestParameters: BulkImportVehicleModelReferencesOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<BulkImportResult> {
        const response = await this.bulkImportVehicleModelReferencesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create a single catalog entry. Requires system_vehicle_model_manage.
     */
    async createVehicleModelReferenceRaw(
        requestParameters: CreateVehicleModelReferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreateUpdateVehicleModelReferenceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a single catalog entry. Requires system_vehicle_model_manage.
     */
    async createVehicleModelReference(
        requestParameters: CreateVehicleModelReferenceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createVehicleModelReferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete a catalog entry. Requires system_vehicle_model_manage.
     */
    async deleteVehicleModelReferenceRaw(
        requestParameters: DeleteVehicleModelReferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["id"] == null) {
            throw new runtime.RequiredError(
                "id",
                'Required parameter "id" was null or undefined when calling deleteVehicleModelReference().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references/{id}`.replace(
                    `{${"id"}}`,
                    encodeURIComponent(String(requestParameters["id"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete a catalog entry. Requires system_vehicle_model_manage.
     */
    async deleteVehicleModelReference(
        requestParameters: DeleteVehicleModelReferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteVehicleModelReferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Returns the sorted list of canonical vehicle makes from the reference catalog. Suitable as a create-form dropdown source.
     */
    async getVehicleModelReferenceMakesRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references/makes`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns the sorted list of canonical vehicle makes from the reference catalog. Suitable as a create-form dropdown source.
     */
    async getVehicleModelReferenceMakes(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<string>> {
        const response =
            await this.getVehicleModelReferenceMakesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the catalog models (with vehicle type and battery capacity) for a given make. Suitable as a dependent create-form dropdown that pre-fills specs.
     */
    async getVehicleModelReferenceModelsRaw(
        requestParameters: GetVehicleModelReferenceModelsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<VehicleModelOptionDto>>> {
        if (requestParameters["make"] == null) {
            throw new runtime.RequiredError(
                "make",
                'Required parameter "make" was null or undefined when calling getVehicleModelReferenceModels().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["make"] != null) {
            queryParameters["make"] = requestParameters["make"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references/models`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(VehicleModelOptionDtoFromJSON),
        );
    }

    /**
     * Returns the catalog models (with vehicle type and battery capacity) for a given make. Suitable as a dependent create-form dropdown that pre-fills specs.
     */
    async getVehicleModelReferenceModels(
        requestParameters: GetVehicleModelReferenceModelsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<VehicleModelOptionDto>> {
        const response = await this.getVehicleModelReferenceModelsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update a catalog entry. Requires system_vehicle_model_manage.
     */
    async updateVehicleModelReferenceRaw(
        requestParameters: UpdateVehicleModelReferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["id"] == null) {
            throw new runtime.RequiredError(
                "id",
                'Required parameter "id" was null or undefined when calling updateVehicleModelReference().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references/{id}`.replace(
                    `{${"id"}}`,
                    encodeURIComponent(String(requestParameters["id"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: CreateUpdateVehicleModelReferenceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update a catalog entry. Requires system_vehicle_model_manage.
     */
    async updateVehicleModelReference(
        requestParameters: UpdateVehicleModelReferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateVehicleModelReferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData endpoint listing the full vehicle make/model reference catalog. Requires system_vehicle_model_manage.
     */
    async vehicleModelReferencesODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<VehicleModelReferenceDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle-model-references-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(VehicleModelReferenceDtoFromJSON),
        );
    }

    /**
     * OData endpoint listing the full vehicle make/model reference catalog. Requires system_vehicle_model_manage.
     */
    async vehicleModelReferencesOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<VehicleModelReferenceDto>> {
        const response =
            await this.vehicleModelReferencesODataRaw(initOverrides);
        return await response.value();
    }
}
